import styled, { css } from 'styled-components';
import { memMarkdownContent } from '../MemMarkdown/styles';

export const NuggetCard = styled.div<{ $overlay?: boolean }>(
  ({ theme, $overlay }) => css`
    background-color: ${$overlay ? 'transparent' : theme.co.secondary99};
    border-radius: ${theme.sz.s2};
    padding: ${$overlay ? 0 : theme.sz.s3};
    width: ${$overlay ? '100%' : '280px'};
    max-width: 100%;
    box-sizing: border-box;

    @media (max-width: ${theme.sz.md}) {
      width: 100%;
    }
  `,
);

export const NuggetHeader = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s1};
    margin-bottom: ${theme.sz.s1};
  `,
);

export const NuggetEmoji = styled.span(
  ({ theme }) => css`
    font-size: ${theme.sz.s4};
  `,
);

export const NuggetTitle = styled.span<{ $overlay?: boolean }>(
  ({ theme, $overlay }) => css`
    ${theme.typography.heading.desktop.xxxs};
    color: ${$overlay ? theme.co.neutral99 : theme.co.neutral10};
  `,
);

export const NuggetPreview = styled.div<{ $expanded?: boolean; $overlay?: boolean }>(
  ({ theme, $expanded, $overlay }) => css`
    ${theme.typography.paragraph.s};
    ${memMarkdownContent(theme)};
    color: ${$overlay ? theme.co.neutral90 : theme.co.neutral30};
    margin: 0 0 ${$expanded ? 0 : theme.sz.s2} 0;

    ${
      !$expanded &&
      css`
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      `
    }
  `,
);

export const LearnMoreLink = styled.button<{ $overlay?: boolean }>(
  ({ theme, $overlay }) => css`
    ${theme.typography.paragraph.s};
    color: ${$overlay ? theme.co.primary50 : theme.co.primary20};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-weight: ${theme.DEPRECATED_ty.bold};
    text-transform: uppercase;

    &:hover {
      text-decoration: underline;
      color: ${$overlay ? theme.co.primary60 : theme.co.primary20};
    }
  `,
);

export const ModalContent = styled.div(
  ({ theme }) => css`
    padding: ${theme.sz.s6};
    max-width: ${theme.sz.xl};
    width: 100%;
  `,
);

export const ModalTitle = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    color: ${theme.co.neutral10};
    margin: 0 0 ${theme.sz.s4} 0;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.s};
    }
  `,
);

export const NuggetText = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    ${memMarkdownContent(theme)};
    color: ${theme.co.neutral20};
    margin: 0 0 ${theme.sz.s6} 0;
  `,
);

export const ButtonContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    margin-top: ${theme.sz.s4};
  `,
);
